import Controller from '@ember/controller';
import { computed, get, set } from '@ember/object';
import { service } from '@ember/service';
import { sortByProperties } from 'donor-elf-web/lib/array-utils';
import { task } from 'ember-concurrency';

export default Controller.extend({
  router: service(),
  store: service(),
  storeCache: service(),

  errorMessage: null,

  filteredRoles: computed('model.roles', function (role) {
    return get(this, 'model.roles').filter((role) => {
      return get(role, 'name') !== 'Org-Admin';
    });
  }),
  rolesSortBy: ['name'],
  sortedRoles: computed('filteredRoles', 'rolesSortBy', function () {
    let roles = get(this, 'filteredRoles');
    let rolesSortBy = get(this, 'rolesSortBy');
    return sortByProperties(roles, rolesSortBy);
  }),
  roleOptions: computed('sortedRoles', function () {
    return this.sortedRoles.map((r) => r.name);
  }),

  save: task(function* () {
    let changeset = get(this, 'model.userFundChangeset');
    let user = get(this, 'model.user');
    if (get(changeset, 'role') === get(user, 'role')) {
      set(changeset, 'role', null);
    }
    yield changeset.save();
    this.router.transitionTo('admin.users.show');
  }).drop(),
});
